import {
  Box,
  HStack,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
  VStack,
} from "@chakra-ui/react";
import { XCircle } from "phosphor-react";
import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { COLORS } from "../../Helper/Colors";

const ViewStaticPage = ({ type, initialValues, onClose, handleModal }) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      width={"100%"}
      height={"100%"}
      overflow={"auto"}
      padding={4}
      paddingBottom={2}
    >
      <ModalHeader
        display={"flex"}
        flex="1"
        width={"100%"}
        justifyContent={"space-between"}
        alignItems="center"
      >
        <HStack
          display={"flex"}
          justifyContent={"center"}
          flex="1"
          alignItems="center"
          fontWeight={"600"}
        >
          <Text>Static Page Information</Text>
        </HStack>
        <XCircle
          height="24"
          width="24"
          onClick={onClose}
          cursor={"pointer"}
          color={COLORS.lightGray}
        />
      </ModalHeader>

      <ModalBody className={"design-scrollbar"}>
        <VStack spacing={4} width={"100%"} alignItems={"stretch"}>
          <Box>
            <Text marginBottom={"3px"} fontWeight={"bold"}>
              Page Name
            </Text>
            <Text>{initialValues.title}</Text>
          </Box>
          <Box>
            <Text marginBottom={"1px"} fontWeight={"bold"}>
              Content
            </Text>
            <Box
              border={"1px solid"}
              borderColor={COLORS.gray}
              padding={4}
              paddingLeft={8}
              borderRadius="lg"
              dangerouslySetInnerHTML={{ __html: initialValues.content }}
            />
          </Box>
        </VStack>
      </ModalBody>
      <ModalFooter justifyContent={"flex-start"}></ModalFooter>
    </Box>
  );
};

export default ViewStaticPage;
